document.addEventListener('DOMContentLoaded', () => {

  const megaMenus = document.querySelectorAll('.mega-menu');

  megaMenus.forEach(megaMenu => {
    const mainLinks = megaMenu.querySelectorAll('.mega-menu-link-group');
    const secondColumns = megaMenu.querySelectorAll('.mega-menu-second-column');
    const thirdColumnContainer = megaMenu.querySelector('.mega-menu-third-column');
    const thirdCards = megaMenu.querySelectorAll('.mega-menu__card');
    const secondColumnContainer = megaMenu.querySelector('.mega-menu-second-column-container');
    const megaMenuMask = megaMenu.nextElementSibling;

    // Initially hide second column container, third column container, and third cards
    if (secondColumnContainer) secondColumnContainer.classList.remove('active');
    if (thirdColumnContainer) thirdColumnContainer.classList.remove('active');
    secondColumns.forEach(col => col.classList.remove('active'));
    thirdCards.forEach(card => card.classList.remove('active'));

    // Function to toggle body scroll
    const toggleBodyScroll = (lock) => {
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      document.body.style.overflow = lock ? 'hidden' : '';
      document.body.style.paddingRight = lock ? scrollbarWidth + 'px' : '';
      // Force reflow for Safari
      megaMenuMask.offsetHeight;
      megaMenuMask.style.display = lock ? 'block' : 'none';
      megaMenuMask.style.pointerEvents = lock ? 'auto' : 'none';
      // Force another reflow
      megaMenuMask.offsetHeight;
    };

    // Function to check if second column has <a> tags in <li> elements
    const checkSecondColumnLinks = (secondColumn) => {
      const hasLinks = secondColumn.querySelectorAll('li a').length > 0;
      if (!hasLinks) {
        secondColumn.classList.remove('active');
      } else {
        secondColumn.classList.add('active');
      }
      return hasLinks;
    };

    // Handle main link clicks
    mainLinks.forEach(group => {
      const link = group.querySelector('.mega-menu-main-link');
      const menuParent = group.dataset.menuParent;

      link.addEventListener('click', (e) => {
        // Skip if this is a span (item-without-link) - it's not clickable anyway
        if (link.tagName === 'SPAN') {
          return;
        }

        // Get the href attribute value
        const linkUrl = link.getAttribute('href') || '';
        
        // If href is only "#" or empty, this is a mega-menu trigger, not a navigation link
        const isMegaMenuTrigger = linkUrl === '#' || linkUrl === '';

        // If this is NOT a mega-menu trigger (has a real URL), allow navigation
        if (!isMegaMenuTrigger) {
          return;
        }

        // Check if this main link has a second column (sub-links)
        const secondColumn = megaMenu.querySelector(`.mega-menu-second-column[data-parent="${menuParent}"]`);
        const hasSecondColumn = secondColumn && secondColumn.querySelectorAll('li a').length > 0;

        // Only prevent default and show mega-menu if this link has sub-links
        if (hasSecondColumn) {
          e.preventDefault();

          // Check if this main link is already active - if so, close level 2
          const isAlreadyActive = group.classList.contains('mega-menu-link-group-active');

          if (isAlreadyActive) {
            // Close level 2 and level 3
            secondColumns.forEach(col => col.classList.remove('active'));
            thirdCards.forEach(card => card.classList.remove('active'));
            const thirdColumnLists = megaMenu.querySelectorAll('.mega-menu-third-column-list');
            thirdColumnLists.forEach(list => list.classList.remove('active'));
            if (thirdColumnContainer) thirdColumnContainer.classList.remove('active');
            if (secondColumnContainer) secondColumnContainer.classList.remove('active');

            // Remove active class from all main links and child links
            mainLinks.forEach(g => {
              g.classList.remove('mega-menu-link-group-active');
              const gLink = g.querySelector('.mega-menu-main-link');
              if (gLink) gLink.setAttribute('aria-expanded', 'false');
            });
            const allChildLinks = megaMenu.querySelectorAll('.second-column-li');
            allChildLinks.forEach(li => li.classList.remove('active'));

            megaMenu.classList.remove('third-column-only');
            
            // Force reflow for Safari
            megaMenu.offsetHeight;
            return;
          }

          // Hide all second columns, third cards, third column lists, and deactivate third column container
          secondColumns.forEach(col => {
            col.classList.remove('active');
          });
          thirdCards.forEach(card => card.classList.remove('active'));
          const thirdColumnLists = megaMenu.querySelectorAll('.mega-menu-third-column-list');
          thirdColumnLists.forEach(list => list.classList.remove('active'));
          if (thirdColumnContainer) thirdColumnContainer.classList.remove('active');
          
          // Remove active class from all second column containers
          const allSecondColumnContainers = megaMenu.querySelectorAll('.mega-menu-second-column-container');
          allSecondColumnContainers.forEach(container => {
            container.classList.remove('active');
          });

          // Remove active class from all main links and child links
          mainLinks.forEach(g => {
            g.classList.remove('mega-menu-link-group-active');
            const gLink = g.querySelector('.mega-menu-main-link');
            if (gLink) gLink.setAttribute('aria-expanded', 'false');
          });
          const allChildLinks = megaMenu.querySelectorAll('.second-column-li');
          allChildLinks.forEach(li => li.classList.remove('active'));

          // Add active class to clicked main link
          group.classList.add('mega-menu-link-group-active');
          link.setAttribute('aria-expanded', 'true');

          // Show corresponding second column
          if (secondColumn) {
            const hasLinks = checkSecondColumnLinks(secondColumn);
            if (secondColumnContainer) {
              if (hasLinks) {
                secondColumnContainer.classList.add('active');
                megaMenu.classList.remove('third-column-only');
              } else {
                secondColumnContainer.classList.remove('active');
                megaMenu.classList.add('third-column-only');
              }
            }
          } else {
            if (secondColumnContainer) {
              secondColumnContainer.classList.remove('active');
              megaMenu.classList.add('third-column-only');
            }
          }

          // Show corresponding third column
          const thirdCard = megaMenu.querySelector(`.mega-menu__card[data-parent="${menuParent}"]`);
          if (thirdCard) {
            thirdCard.classList.add('active');
            if (thirdColumnContainer) {
              thirdColumnContainer.classList.add('active');
            }
          }
        } else {
          // This main link doesn't have sub-links, allow normal navigation
        }
      });
    });

    // Handle child link clicks for third column
    const childLinks = megaMenu.querySelectorAll('.mega-menu-child-link');
    const thirdColumnLists = megaMenu.querySelectorAll('.mega-menu-third-column-list');

    childLinks.forEach(childLink => {
      childLink.addEventListener('click', (e) => {
        // Skip if this is a span (item-without-link) - it's not clickable anyway
        if (childLink.tagName === 'SPAN') {
          return;
        }

        const menuId = childLink.dataset.menuId;
        const parentColumn = childLink.closest('.mega-menu-second-column');
        const menuParent = parentColumn ? parentColumn.dataset.parent : null;

        // Check if this link has a corresponding third column list
        const thirdColumnList = megaMenu.querySelector(`.mega-menu-third-column-list[data-parent="${menuParent}"][data-child="${menuId}"]`);
        
        if (thirdColumnList) {
          // This link has sub-links, prevent navigation and show third column
          e.preventDefault();
          
          // Check if this child link is already active - if so, close level 3
          const isAlreadyActive = childLink.parentElement.classList.contains('active');
          
          if (isAlreadyActive) {
            // Close level 3
            const allThirdColumnLists = megaMenu.querySelectorAll('.mega-menu-third-column-list');
            allThirdColumnLists.forEach(list => {
              list.classList.remove('active');
            });

            // Remove active class from all child links
            const allSecondColumnLis = megaMenu.querySelectorAll('.second-column-li');
            allSecondColumnLis.forEach(li => li.classList.remove('active'));

            // Deactivate third column container
            if (thirdColumnContainer) thirdColumnContainer.classList.remove('active');
            
            // Force reflow for Safari
            megaMenu.offsetHeight;
            return;
          }
          
          // Hide all third column lists first
          const allThirdColumnLists = megaMenu.querySelectorAll('.mega-menu-third-column-list');
          allThirdColumnLists.forEach(list => {
            list.classList.remove('active');
          });

          // Remove active class from all child links in all second columns
          const allSecondColumnLis = megaMenu.querySelectorAll('.second-column-li');
          allSecondColumnLis.forEach(li => li.classList.remove('active'));

          // Add active class to clicked child link's parent li
          childLink.parentElement.classList.add('active');

          // Show corresponding third column list and activate the container
          thirdColumnList.classList.add('active');
          if (thirdColumnContainer) {
            thirdColumnContainer.classList.add('active');
          }
        }
        // else: This link doesn't have sub-links, allow normal navigation
      });
    });

    // Add click handler to mask to close menu
    megaMenuMask.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      resetMegaMenu();
    });
    
    // Additional touch handler for better iOS/Safari support
    megaMenuMask.addEventListener('touchend', (e) => {
      e.preventDefault();
      e.stopPropagation();
      resetMegaMenu();
    }, { passive: false });
  });

  // Function to reset internal state of mega menu (all active columns, links, cards)
  function resetMegaMenuInternalState(megaMenu) {
    // Remove all active states from columns
    const secondColumns = megaMenu.querySelectorAll('.mega-menu-second-column');
    const thirdCards = megaMenu.querySelectorAll('.mega-menu__card');
    const thirdColumnLists = megaMenu.querySelectorAll('.mega-menu-third-column-list');
    const thirdColumnContainer = megaMenu.querySelector('.mega-menu-third-column');
    const secondColumnContainer = megaMenu.querySelector('.mega-menu-second-column-container');
    const mainLinks = megaMenu.querySelectorAll('.mega-menu-link-group');
    const allChildLinks = megaMenu.querySelectorAll('.second-column-li');

    // Hide all second columns
    secondColumns.forEach(col => col.classList.remove('active'));

    // Hide all third cards
    thirdCards.forEach(card => card.classList.remove('active'));

    // Hide all third column lists
    thirdColumnLists.forEach(list => list.classList.remove('active'));

    // Deactivate third column container
    if (thirdColumnContainer) thirdColumnContainer.classList.remove('active');

    // Deactivate second column container
    if (secondColumnContainer) secondColumnContainer.classList.remove('active');
    
    // Remove active class from all main links
    mainLinks.forEach(g => {
      g.classList.remove('mega-menu-link-group-active');
      const gLink = g.querySelector('.mega-menu-main-link');
      if (gLink) gLink.setAttribute('aria-expanded', 'false');
    });
    
    // Remove active class from all child links
    allChildLinks.forEach(li => li.classList.remove('active'));
    
    // Remove third-column-only class
    megaMenu.classList.remove('third-column-only');
    
    // Force reflow for Safari
    megaMenu.offsetHeight;
  }

  function resetMegaMenu() {
    const megaMenus = document.querySelectorAll('.mega-menu');
    megaMenus.forEach(megaMenu => {
      megaMenu.classList.remove('active');
      // Reset internal state of each menu
      resetMegaMenuInternalState(megaMenu);
    });
    const megaMenuMasks = document.querySelectorAll('[data-mega-menu-mask]');
    megaMenuMasks.forEach(mask => {
      mask.classList.remove('active')
    });
    const summaryLinks = document.querySelectorAll('[data-header-menu-summary]');
    summaryLinks.forEach(summary => {
      summary.classList.remove('active')
      summary.setAttribute('aria-expanded', 'false')
    });
    const megaMenuPrimaryNavItems = document.querySelectorAll('.header__primary-nav-item')
    megaMenuPrimaryNavItems.forEach(navItem => {
      navItem && navItem.classList.remove('mega-menu-is-active')
    })
    // Restore body scroll
    document.body.style.overflow = ''
    document.body.style.paddingRight = ''
  }

  function checkThirdColumnOnly(megaMenu) {
    const secondColumns = megaMenu.querySelectorAll('.mega-menu-second-column');
    let hasAnyLinks = false;
    
    secondColumns.forEach(column => {
      // Only check columns that are active or have the active class
      if (column.classList.contains('active') || column.parentElement.classList.contains('active')) {
        const links = column.querySelectorAll('li a');
        if (links.length > 0) {
          hasAnyLinks = true;
        }
      }
    });

    if (!hasAnyLinks) {
      megaMenu.classList.add('third-column-only');
    } else {
      megaMenu.classList.remove('third-column-only');
    }
  }

  document.querySelectorAll('[data-header-menu-details]').forEach(details => {
    const summary = details.querySelector('[data-header-menu-summary]');
    summary.addEventListener('click', e => {

      e.preventDefault() // Stop the toggle behavior
      details.setAttribute('open', '') // Open the details element

      resetMegaMenu()

      const clickedMegaMenu = details.querySelector('.mega-menu')
      const clickedMegaMenuMask = details.querySelector('[data-mega-menu-mask]')

      if (clickedMegaMenu.classList.contains('active')) {
        clickedMegaMenu.classList.remove('active')
        clickedMegaMenuMask.classList.remove('active')
        summary.classList.remove('active')
        summary.setAttribute('aria-expanded', 'false')
        document.body.style.overflow = ''
        document.body.style.paddingRight = ''
        // Reset internal state when closing
        resetMegaMenuInternalState(clickedMegaMenu);
      } else {
        clickedMegaMenu.classList.add('active')
        clickedMegaMenuMask.classList.add('active')
        summary.classList.add('active')
        summary.setAttribute('aria-expanded', 'true')
        const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
        document.body.style.overflow = 'hidden'
        document.body.style.paddingRight = scrollbarWidth + 'px'
        
        // Force reflow for Safari
        clickedMegaMenuMask.offsetHeight;
        clickedMegaMenu.offsetHeight;
        
        // Check for third-column-only after a small delay to ensure DOM is updated
        setTimeout(() => {
          checkThirdColumnOnly(clickedMegaMenu);
        }, 0);
      }

      const megaMenuPrimaryNavItems = document.querySelectorAll('.header__primary-nav-item')
      megaMenuPrimaryNavItems.forEach(navItem => {
        navItem && navItem.classList.add('mega-menu-is-active')
      })

    })
  })

  // Close mega menu on Escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      resetMegaMenu();
    }
  });

  // const megaMenuHoverCards = document.querySelectorAll('[data-menu-card-id]')
  // const withHoverLinks = document.querySelectorAll('[data-mega-menu-child-link-with-hover]')
  // if (megaMenuHoverCards.length > 0) {
  //   megaMenuHoverCards[0].classList.add('active')
  // }
  // withHoverLinks.forEach(withHoverLink => {
  //   withHoverLink.addEventListener('mouseover', () => {
  //     const hoverValue = withHoverLink.dataset.megaMenuChildLinkWithHover
  //     megaMenuHoverCards.forEach(card => {
  //       const cardValue = card.dataset.menuCardId
  //       if (hoverValue === cardValue) {
  //         megaMenuHoverCards.forEach(item => item.classList.remove('active'))
  //         card.classList.add('active')
  //       }
  //     })
  //   })
  // })

});
